var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    {
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "filter-container" },
                [
                  _c("el-input", {
                    staticClass: "filter-item",
                    staticStyle: { width: "200px" },
                    attrs: { placeholder: "等级代号", clearable: "" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleFilter($event)
                      },
                    },
                    model: {
                      value: _vm.listQuery.levelId,
                      callback: function ($$v) {
                        _vm.$set(_vm.listQuery, "levelId", $$v)
                      },
                      expression: "listQuery.levelId",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-input", {
                    staticClass: "filter-item",
                    staticStyle: { width: "200px" },
                    attrs: { placeholder: "等级名称", clearable: "" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleFilter($event)
                      },
                    },
                    model: {
                      value: _vm.listQuery.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.listQuery, "name", $$v)
                      },
                      expression: "listQuery.name",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      directives: [
                        { name: "waves", rawName: "v-waves" },
                        {
                          name: "has",
                          rawName: "v-has",
                          value: "sysOrgGroup:list",
                          expression: "'sysOrgGroup:list'",
                        },
                      ],
                      staticClass: "filter-item",
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.handleFilter },
                    },
                    [_vm._v("\n        搜索\n      ")]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          key: _vm.tableKey,
          staticStyle: { width: "100%" },
          attrs: {
            "max-height": _vm.maxHeight,
            data: _vm.orgGroupList,
            stripe: "",
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "等级代号",
              prop: "levelId",
              align: "center",
              width: "100",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "等级名称",
              prop: "name",
              align: "center",
              "min-width": "120",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "等级背景",
              prop: "backgroundUrl",
              align: "center",
              "min-width": "160",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.backgroundUrl === null ||
                    row.backgroundUrl === "" ||
                    row.backgroundUrl === undefined
                      ? _c("span", [_vm._v("\n          未上传图片\n        ")])
                      : _c("el-image", {
                          staticStyle: { width: "80px", height: "40px" },
                          attrs: {
                            src: _vm.resPath + row.backgroundUrl,
                            fit: "contain",
                            "preview-src-list": [
                              _vm.resPath + row.backgroundUrl,
                            ],
                            "preview-teleported": "",
                          },
                        }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "等级卡片",
              prop: "backgroundCardUrl",
              align: "center",
              "min-width": "160",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.backgroundCardUrl === null ||
                    row.backgroundCardUrl === "" ||
                    row.backgroundCardUrl === undefined
                      ? _c("span", [_vm._v("\n          未上传图片\n        ")])
                      : _c("el-image", {
                          staticStyle: { width: "80px", height: "40px" },
                          attrs: {
                            src: _vm.resPath + row.backgroundCardUrl,
                            fit: "contain",
                            "preview-src-list": [
                              _vm.resPath + row.backgroundCardUrl,
                            ],
                            "preview-teleported": "",
                          },
                        }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "等级图标",
              prop: "backgroundUiUrl",
              align: "center",
              "min-width": "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.backgroundUiUrl === null ||
                    row.backgroundUiUrl === "" ||
                    row.backgroundUiUrl === undefined
                      ? _c("span", [_vm._v("\n          未上传图片\n        ")])
                      : _c("el-image", {
                          staticStyle: { width: "80px", height: "40px" },
                          attrs: {
                            src: _vm.resPath + row.backgroundUiUrl,
                            fit: "contain",
                            "preview-src-list": [
                              _vm.resPath + row.backgroundUiUrl,
                            ],
                            "preview-teleported": "",
                          },
                        }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "等级弹框",
              prop: "field1",
              align: "center",
              "min-width": "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.field1 === null ||
                    row.field1 === "" ||
                    row.field1 === undefined
                      ? _c("span", [_vm._v("\n          未上传图片\n        ")])
                      : _c("el-image", {
                          staticStyle: { width: "80px", height: "40px" },
                          attrs: {
                            src: _vm.resPath + row.field1,
                            fit: "contain",
                            "preview-src-list": [_vm.resPath + row.field1],
                            "preview-teleported": "",
                          },
                        }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "无奖励等级弹框",
              prop: "field3",
              align: "center",
              "min-width": "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.field3 === null ||
                    row.field3 === "" ||
                    row.field3 === undefined
                      ? _c("span", [_vm._v("\n          未上传图片\n        ")])
                      : _c("el-image", {
                          staticStyle: { width: "80px", height: "40px" },
                          attrs: {
                            src: _vm.resPath + row.field3,
                            fit: "contain",
                            "preview-src-list": [_vm.resPath + row.field3],
                            "preview-teleported": "",
                          },
                        }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("tableFrom.CreationTime"),
              width: "100px",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("parseTime")(
                            row.createTime,
                            "{y}-{m}-{d} {h}:{i}:{s}"
                          )
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("tableFrom.UpdateTime"),
              width: "100px",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("parseTime")(
                            row.updateTime,
                            "{y}-{m}-{d} {h}:{i}:{s}"
                          )
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              label: _vm.$t("tableFrom.Operation"),
              align: "center",
              width: "250",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "warning",
                              icon: "el-icon-upload",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleUploadDialog(row)
                              },
                            },
                          },
                          [_vm._v("\n            上传\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "success",
                              icon: "el-icon-collection",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openEquitiesDialog(row)
                              },
                            },
                          },
                          [_vm._v("\n            权益管理\n          ")]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.total > 0
        ? _c("sw-page", {
            key: "2",
            attrs: {
              listQuery: _vm.listQuery,
              total: _vm.total,
              pos: "btmRight",
            },
            on: { retPage: _vm.retPage },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "上传背景图",
            visible: _vm.uploadDialog.visible,
            size: "40%",
            direction: "rtl",
            "with-header": true,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.uploadDialog, "visible", $event)
            },
            close: _vm.resetUpload,
          },
        },
        [
          _c(
            "el-form",
            {
              staticClass: "upload-form",
              attrs: { model: _vm.editFormPhoto, "label-width": "80px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "等级背景", prop: "backgroundUrl" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-demo",
                      attrs: {
                        action: "#",
                        "http-request": _vm.handlePictureUploadOne,
                        "on-remove": _vm.handleRemoveFileOne,
                        "on-preview": _vm.handlePreviewOne,
                        "list-type": "picture-card",
                        "auto-upload": true,
                        accept: "image/*",
                        "file-list": _vm.uploadFileListOne,
                      },
                    },
                    [_c("i", { staticClass: "el-icon-plus" })]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "upload-tip" }, [
                    _vm._v(
                      "图片格式：jpg/png，大小≤2MB，尺寸305px*402px, 或同比例图片"
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "等级卡片", prop: "backgroundCardUrl" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-demo",
                      attrs: {
                        action: "#",
                        "http-request": _vm.handlePictureUploadTwo,
                        "on-remove": _vm.handleRemoveFileTwo,
                        "on-preview": _vm.handlePreviewTwo,
                        "list-type": "picture-card",
                        "auto-upload": true,
                        accept: "image/*",
                        "file-list": _vm.uploadFileListTwo,
                      },
                    },
                    [_c("i", { staticClass: "el-icon-plus" })]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "upload-tip" }, [
                    _vm._v(
                      "图片格式：jpg/png，大小≤2MB，尺寸360px*220px, 或同比例图片"
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "等级图标", prop: "backgroundUiUrl" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-demo",
                      attrs: {
                        action: "#",
                        "http-request": _vm.handlePictureUploadThree,
                        "on-remove": _vm.handleRemoveFileThree,
                        "on-preview": _vm.handlePreviewThree,
                        "list-type": "picture-card",
                        "auto-upload": true,
                        accept: "image/*",
                        "file-list": _vm.uploadFileListThree,
                      },
                    },
                    [_c("i", { staticClass: "el-icon-plus" })]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "upload-tip" }, [
                    _vm._v(
                      "图片格式：jpg/png，大小≤2MB，尺寸360px*360px,注意:金卡图标为\n          360px*328px,黑金卡图标为360px*322px,钻石卡为360px*302px,或同比例图片"
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "等级弹框", prop: "field1" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-demo",
                      attrs: {
                        action: "#",
                        "http-request": _vm.handlePictureUploadFour,
                        "on-remove": _vm.handleRemoveFileFour,
                        "on-preview": _vm.handlePreviewFour,
                        "list-type": "picture-card",
                        "auto-upload": true,
                        accept: "image/*",
                        "file-list": _vm.uploadFileListFour,
                      },
                    },
                    [_c("i", { staticClass: "el-icon-plus" })]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "upload-tip" }, [
                    _vm._v(
                      "图片格式：jpg/png，大小≤2MB，尺寸360px*437px, 或同比例图片"
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "无奖励等级弹框" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-demo",
                      attrs: {
                        action: "#",
                        "http-request": _vm.handlePictureUploadFive,
                        "on-remove": _vm.handleRemoveFileFive,
                        "on-preview": _vm.handlePreviewFive,
                        "list-type": "picture-card",
                        "auto-upload": true,
                        accept: "image/*",
                        "file-list": _vm.uploadFileListFive,
                      },
                    },
                    [_c("i", { staticClass: "el-icon-plus" })]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "upload-tip" }, [
                    _vm._v(
                      "图片格式：jpg/png，大小≤2MB，尺寸360px*437px, 或同比例图片"
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "drawer-footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.uploadDialog.visible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleUploadConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.previewDialogOne.visible, width: "400px" },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.previewDialogOne, "visible", $event)
            },
          },
        },
        [
          _c("img", {
            staticStyle: { width: "100%" },
            attrs: { src: _vm.previewDialogOne.url, alt: "预览图" },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.previewDialogTwo.visible, width: "400px" },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.previewDialogTwo, "visible", $event)
            },
          },
        },
        [
          _c("img", {
            staticStyle: { width: "100%" },
            attrs: { src: _vm.previewDialogTwo.url, alt: "预览图" },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.previewDialogThree.visible, width: "400px" },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.previewDialogThree, "visible", $event)
            },
          },
        },
        [
          _c("img", {
            staticStyle: { width: "100%" },
            attrs: { src: _vm.previewDialogThree.url, alt: "预览图" },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.previewDialogFour.visible, width: "400px" },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.previewDialogFour, "visible", $event)
            },
          },
        },
        [
          _c("img", {
            staticStyle: { width: "100%" },
            attrs: { src: _vm.previewDialogFour.url, alt: "预览图" },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticStyle: { "margin-bottom": "40px" },
          attrs: {
            title: "等级权益管理：" + _vm.currentGrade.name,
            visible: _vm.equitiesDialogVisible,
            width: "800px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.equitiesDialogVisible = $event
            },
          },
        },
        [
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { placeholder: "标题", clearable: "" },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.fetchEquities(_vm.currentGrade)
              },
            },
            model: {
              value: _vm.currentGrade.title,
              callback: function ($$v) {
                _vm.$set(_vm.currentGrade, "title", $$v)
              },
              expression: "currentGrade.title",
            },
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", icon: "el-icon-search" },
              on: {
                click: function ($event) {
                  return _vm.fetchEquities(_vm.currentGrade)
                },
              },
            },
            [_vm._v("搜索")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", icon: "el-icon-circle-plus-outline" },
              on: { click: _vm.handleAddEquity },
            },
            [_vm._v("新增")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "margin-top": "10px", "padding-bottom": "10px" } },
            [
              _c(
                "el-table",
                {
                  staticStyle: { "margin-top": "10px" },
                  attrs: { "max-height": "400px", data: _vm.equitiesList },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "标题", prop: "title" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "描述", prop: "describe" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      sortable: "",
                      label: "排序",
                      prop: "field1",
                      "sort-by": _vm.sortByField1,
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "图片", prop: "picturePath" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("el-image", {
                              staticStyle: { width: "60px", height: "30px" },
                              attrs: { src: _vm.resPath + row.picturePath },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "锁定状态", prop: "lockStatus" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(row.lockStatus === 0 ? "开放" : "锁定")
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作", align: "center", width: "250" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  icon: "el-icon-edit",
                                  size: "mini",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.editEquity(row)
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  type: "danger",
                                  icon: "el-icon-delete",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteEquity(row)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { margin: "10px" } },
                [
                  _c("el-pagination", {
                    staticStyle: { float: "right", "padding-bottom": "30px" },
                    attrs: {
                      background: "",
                      layout: "prev, pager, next, sizes, total, jumper",
                      "current-page": _vm.currentGrade.page,
                      "page-size": _vm.currentGrade.limit,
                    },
                    on: {
                      "current-change": _vm.handleEquityPageChange,
                      "size-change": _vm.handleEquitySizeChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.editForm.id ? "编辑权益" : "新增权益",
            visible: _vm.editEquityVisible,
            width: "500px",
            "append-to-body": "",
          },
          on: {
            close: _vm.equitiesDialogClose,
            "update:visible": function ($event) {
              _vm.editEquityVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "editFormRef",
              staticClass: "dialog-form",
              attrs: {
                model: _vm.editForm,
                "label-width": "80px",
                rules: _vm.equityRules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "标题", prop: "title" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.editForm.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "title", $$v)
                      },
                      expression: "editForm.title",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "描述", prop: "describe" } },
                [
                  _c("el-input", {
                    attrs: { autosize: "", type: "textarea" },
                    model: {
                      value: _vm.editForm.describe,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "describe", $$v)
                      },
                      expression: "editForm.describe",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "锁定状态", prop: "lockStatus" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.editForm.lockStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.editForm, "lockStatus", $$v)
                        },
                        expression: "editForm.lockStatus",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("开放")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("锁定")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "排序" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0 },
                    model: {
                      value: _vm.editForm.field1,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "field1", $$v)
                      },
                      expression: "editForm.field1",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "展示图片", prop: "picturePath" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-demo",
                      attrs: {
                        action: "#",
                        "on-remove": _vm.handleRemoveFile,
                        "http-request": _vm.handlePictureUpload,
                        "on-preview": _vm.handlePreview,
                        "list-type": "picture-card",
                        "auto-upload": true,
                        accept: "image/*",
                        "file-list": _vm.uploadFileList,
                      },
                    },
                    [_c("i", { staticClass: "el-icon-plus" })]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "upload-tip" }, [
                    _vm._v("图片格式：jpg/png，大小≤2MB，尺寸305*402"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "drawer-footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.editEquityVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveEquity } },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.previewDialog.visible, width: "400px" },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.previewDialog, "visible", $event)
            },
          },
        },
        [
          _c("img", {
            staticStyle: { width: "100%" },
            attrs: { src: _vm.previewDialog.url, alt: "预览图" },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }